import React from 'react';
import { Hero } from './components/Hero';
import { OfferCards } from './components/OfferCards';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-sand-100 font-sans text-slate-800 selection:bg-coral-500 selection:text-white flex flex-col" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <OfferCards data-id="element-3" />
        <ContactSection data-id="element-4" />
      </main>
      <Footer data-id="element-5" />
    </div>;
}